import React from 'react';
import { css } from '@linaria/core';
import { brand, findColorFromCSSVariable } from '@terveystalo/design-system-theme';
import { Subtitle } from '../../atoms/Typography';
import { classnames } from '../../utils';
const determineTextColor = (disabled) => {
    if (disabled) {
        return findColorFromCSSVariable(brand.formControl.color.disabled.content);
    }
    return findColorFromCSSVariable(brand.formControl.color.default.content);
};
export const FormFieldLabel = ({ fieldId, label, disabled, required, as: Component = 'label', className, }) => {
    const color = determineTextColor(disabled);
    return (React.createElement(Component, { htmlFor: fieldId, className: classnames(css `
          text-align: left;
        `, className) },
        React.createElement(Subtitle, { size: "s", color: color }, label),
        required && (React.createElement(Subtitle, { size: "s", color: findColorFromCSSVariable(brand.formControl.color.invalid.content), "aria-hidden": "true", className: css `
            margin-left: 0.125rem;
          ` }, "*"))));
};


import "../../../css/molecules/FormFieldLabel/FormFieldLabel.css";
